var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,on:{"click":function($event){$event.preventDefault();return _vm.$emit('clicked')},"mouseover":_vm.mouseover,"mouseout":_vm.mouseout,"mouseup":_vm.mouseout}},[_vm._v(" "+_vm._s(_vm.caption)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }